import { create } from 'zustand';

type TicketSalesSellableStoreType = {
  sellable: Record<string, number>;
  seedSellable: (entries: Record<string, number>) => void;
  setSellable: (ticketSalesId: string, value: number) => void;
};

export const useTicketSalesSellableStore = create<TicketSalesSellableStoreType>(
  (set) => ({
    sellable: {},
    seedSellable: (entries) => set({ sellable: entries }),
    setSellable: (ticketSalesId, value) =>
      set((state) => ({
        sellable: { ...state.sellable, [ticketSalesId]: value },
      })),
  })
);
